<template>
	<div class="wrapper">
		<div class="use" v-if="status===0 || status===2">
			<div class="head_tip">客服热线 0571-85199986(服务时间8:30-20:00)</div>
			<div class="head">
				<header>
					<div class="lt">
						<p>{{txt}}</p>
						<span>链接有效期至:{{expiredDate}}</span>
					</div>
					<img :src="imgUrl" :alt="txt">
					<span class="ico">电子券</span>
				</header>
			</div>
			<div class="body">
				<header>
					您已选择充值【{{txt}}】，本产品为虚拟产品，请务必核对账户正确，充值后不可撤销且无法退返，直充券码：充值结果请至品牌运营商后台核查，线下商户：请按照券码使用规则使用。
				</header>
				<div class="bd">
					<h1>充值账号</h1>
					<div class="txt"><span>账号</span><input placeholder="请输入账号" v-model="accountNo"></div>
					<div class="txt"><span>再次输入</span><input placeholder="请再次输入账号" v-model="reAccountNo"></div>
					<div class="radio">
						<span>充值类型</span>
						<input type="radio" v-model="charge" name="name" value="帐号直充" checked />帐号直充
						<input type="radio" v-model="charge" name="name" value="点数寄售" />点数寄售
					</div>
				</div>
				<div class="gz">
					<h1>券码规则</h1>
					<div class="tip" v-if="charge=='帐号直充'">
						1.请填写完整帐号(网易通行证)，<span style="color: red;">需要填写帐号后缀</span>，如：@163.com后缀类型。如充错帐号，责任由买家自行承担！
						<br/>2.此产品类型为<span style="color: red;">通用点数</span>，用做网易公司提供的各种增值服务和游戏产品。充值前请仔细核对，充错无法修改。
						<br/>3.通用点数指专门用于网易公司提供的各种增值服务和游戏产品。包括：梦幻西游电脑版、新大话西游2、大话西游2免费版、天下3、新倩女幽魂、镇魂曲、西楚霸王、天谕、大唐无双零、新大话西游3、武魂2、新飞飞、精灵传说、同城约会、VIP邮箱等产品
						<br/>4.通用点数只可消费于网易各产品，战网游戏(魔兽世界、星际争霸、暗黑破坏神、炉石传说、风暴英雄、守望先锋)除外。
						<br/>5.充值比例1元=10点，查询地址<a style="color: blue;" href="http://pay.163.com">http://pay.163.com</a>
						<br/>6.如在购买过程中有任何问题，请拨打客服热线0571-85199986(服务时间8:30-20:00)。
					</div>
					<div class="tip" v-if="charge=='点数寄售'">
						1.请填写完整帐号(网易通行证)，<span style="color: red;">需要填写帐号后缀</span>，如：@163.com后缀类型。如充错帐号，责任由买家自行承担！
						<br/>2.此产品类型为<span style="color: red;">寄售点数</span>，用做点卡交易或者寄售。充值前请仔细核对，充错无法修改。
						<br/>3.寄售点数指专门用于在游戏中进行交易游戏币的点数。目前仅限适用于梦幻西游电脑版、新大话西游2、天下3、新大话西游3经典版(注：免费版无法寄售)、西楚霸王、新飞飞。
						<br/>4.寄售点数只可消费于网易各产品，战网游戏(魔兽世界、星际争霸、暗黑破坏神、炉石传说、风暴英雄、守望先锋)除外。
						<br/>5.充值比例1元=10点，查询地址<a style="color: blue;" href="http://pay.163.com">http://pay.163.com</a>
						<br/>6.如在购买过程中有任何问题，请拨打客服热线0571-85199986(服务时间8:30-20:00)。
					</div>
				</div>
			</div>
			<div class="foot">
				<button @click="submitTX" :disabled="disabled">{{submitTxt}}</button>
			</div>
		</div>
		<div class="use" v-if="status===1 || status===3">
			<div class="head">
				<header class="used">
					<div class="lt">
						<p>{{txt}}</p>
						<span>有效期至:{{expiredDate}}</span>
					</div>
				</header>
			</div>
			<div class="bd1">
				<div class="nodata">
					<img src="../assets/used.png" alt="电子券已使用">
					<p>电子券已使用</p>
				</div>
			</div>
		</div>
		<div class="use" v-if="status===4">
			<div class="head">
				<header class="used">
					<div class="lt">
						<p>{{txt}}</p>
						<span>有效期至:{{expiredDate}}</span>
					</div>
				</header>
			</div>
			<div class="bd1">
				<div class="nodata">
					<img src="../assets/outDate.png" alt="电子券已失效">
					<p>电子券已失效</p>
				</div>
			</div>
		</div>
		<div class="result" v-if="flag">
			<div class="dec">
				<img :src="srcDec" alt="成功">
				<p>{{dec}}</p>
			</div>
		</div>
		<div class="use_loading" v-if="loading">
			<div class="loading">
				<img src="../assets/loading.png" alt="加载中">
			</div>
		</div>
		<!--绑定手机号 -->
		<div class="pop" v-if="popVisible">
			<div class="win">
				<div class="box">
					<h1>手机号验证</h1>
					<div class="txt" v-if="qqAccount==''"><span>手机号</span><input type="number" placeholder="输入手机号" v-model="mobile"></div>
					<div class="txt" v-if="qqAccount!=''" style="margin-bottom:40px"><span>手机号</span><input type="number" placeholder="输入手机号"
						 v-model="mobile"></div>
					<div class="form" v-if="qqAccount==''">
						<div class="code">
							<span>验证码</span>
							<input type="text" placeholder="输入验证码" v-model="verifyCode">
						</div>
						<button v-if="verifyShow" @click="verifyCodeGet(mobile)">获取验证码</button>
						<em v-if="!verifyShow">{{verifyTime}}s</em>
					</div>
					<button class="submit" @click="submitPhone" v-if="qqAccount==''">确认</button>
					<button class="submit" @click="submitVerifyPhone" v-if="qqAccount!=''">确认</button>
				</div>
			</div>
		</div>
		<!-- 未生效弹出层 -->
		<div class="pop" v-if="takeVisible">
			<div class="win">
				<div class="box">
					<h4>电子券有效日期为：</h4>
					<label>生效时间：{{this.effectiveDate}} 00:00:00</label><br />
					<label>失效时间：{{this.expiredDate}} 23:59:59</label><br />
					<br />
					<label>温馨提示：本券码为特殊活动券，超过有效期券码会失效，失效券码请联系原购买渠道，若在有效期内无法使用请联系客服电话:0571-85199986</label>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				qqInfo: 0,
				txt: '云之谷',
				key: this.$route.query.key,
				imgUrl: '',
				accountNo: '',
				reAccountNo: '',
				flag: false,
				disabled: false,
				status: 0,
				submitTxt: '确认充值',
				dec: '',
				srcDec: require('../assets/success.png'),
				seconds: 5,
				loading: true,
				expiredDate: '',
				popVisible: false,
				amount: '',
				productId: '',
				chargeType: 1,
				verifyShow: true,
				visible: true,
				verifyCode: '',
				verifyTime: 60,
				mobile: '',
				qqAccount: '',
				productCategoryId: '',
				// 是否生效，未生效弹出层挡住
				takeVisible: false,
				effectiveDate: '',
				regulation: '',
				charge: '帐号直充'
			}
		},
		mounted() {
			document.title = '云之谷';
			this.getTicketStatus(this.key);
		},
		methods: {
			submitVerifyPhone() {
				if (this.mobile === '') {
					// console.log('充值账户不能为空！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '手机号不能为空';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
				} else {
					const obj = {
						mobile: this.mobile,
						ticketNo: this.key,
						isVerify: 1
					}
					// this.disabled = true;
					this.$http.POST('productTicket/selectProductTicket', obj).then(res => {
						// this.flag = true;
						if (res.code === 0) {
							this.flag = true;
							this.srcDec = require('../assets/success.png');
							this.dec = '验证成功';
							setTimeout((() => {
								this.flag = false;
							}), 1000);
							this.popVisible = false
						} else {
							this.flag = true;
							this.srcDec = require('../assets/fail.png');
							this.dec = res.msg;
							setTimeout((() => {
								this.flag = false;
							}), 1000);
						}
					});
				}
			},
			verifyPhone() {
				if (this.accountNo === '') {
					// console.log('充值账户不能为空！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '手机号不能为空';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
				} else {
					const obj = {
						// mobile:this.accountNo,
						ticketNo: this.key
					}
					this.disabled = true;
					this.$http.POST('productTicket/selectProductTicket', obj).then(res => {
						// this.flag = true;
						if (res.code === 0) {
							// this.starbuckKey = res.data.outTicketPsw;
							this.minus(1);
						} else {
							this.disabled = false;
							this.flag = true;
							this.submitTxt = '确认';
							this.srcDec = require('../assets/fail.png');
							this.dec = res.msg;
							setTimeout((() => {
								this.flag = false;
							}), 1000);
						}
					});
				}
			},
			verifyCodeGet(mobile) {
				if (this.visible) {
					this.visible = false;
					this.$http.POST('sms/send', {
						accountNumber: mobile,
						type: 1
					}).then((res) => {
						this.flag = true;
						if (res.code === 0) {
							this.dec = '验证码发送成功';
							this.srcDec = require('../assets/success.png');
							setTimeout((() => {
								this.flag = false;
							}), 1000);
							this.verifyShow = false;
							const timer = setInterval(() => {
								this.verifyTime--;
								if (this.verifyTime <= 0) {
									this.verifyShow = true;
									this.visible = true;
									clearInterval(timer);
									this.verifyTime = 60;
								}
							}, 1000);
						} else {
							this.srcDec = require('../assets/fail.png');
							this.dec = '验证码发送失败';
							setTimeout((() => {
								this.flag = false;
							}), 1000);
						}
					});
				}
			},
			getTicketStatus(key) {
				const obj = {
					ticketNo: key
				};
				this.$http.POST('productTicket/selectProductTicket', obj).then(res => {
					// console.log(res);
					this.loading = false;
					if (res.code === 0) {
						this.status = res.data.useStatus;
						this.txt = res.data.ticketName;
						this.amount = res.data.amount + '元';
						this.expiredDate = res.data.expiredDate;
						this.imgUrl = res.data.productCategoryList ? res.data.productCategoryList[0].logoPath : '';
						this.chargeType = res.data.productCategoryList ? res.data.productCategoryList[0].chargeType : 1;
						this.fuluProductIdParam = res.data.productCategoryList ? res.data.productCategoryList[0].fuluProductId : '';
						this.productCategoryId = res.data.productCategoryList[0].productCategoryId
						this.productId = res.data.productId
						this.qqAccount = res.data.mobile;
						this.regulation = res.data.regulation;
						this.popVisible = (this.status == 0 || this.status == 2) ? true : false
						document.title = this.txt;
						// 获取生效日期
						this.effectiveDate = res.data.effectiveDate;
						let d = res.data.effectiveDate
						if (d.length === 10) { // 加上时分秒
							d = d + " 00:00:00";
						}
						// 如果未生效，弹出提示
						if (new Date().getTime() < new Date(d).getTime()) {
							this.takeVisible = true
						}
					} else {
						if (res.code === 2000) {
							this.$router.push({
								path: '/404'
							})
						} else {
							alert(res.msg);
						}
					}
				});
			},
			minus(isVerify) {
				var _this = this;
				_this.submitTxt = '充值中...' + _this.seconds + 's';
				var time = window.setInterval(function() {
					if (_this.seconds === 0) {
						_this.seconds = 5;
						window.clearInterval(time);
						if (_this.chargeType == 1) { // 直充
							_this.getOrderInfo(isVerify);
						} else if (_this.chargeType == 2) { // 卡密
							_this.getsecritOrderInfo(isVerify);
						}
					} else {
						_this.submitTxt = '充值中...' + _this.seconds + 's';
						_this.seconds -= 1
					}
				}, 1000)
			},
			submitPhone() {
				const obj = {
					ticketNo: this.key,
					mobile: this.mobile,
					code: this.verifyCode
				}
				this.$http.POST('productTicket/bindMobile', obj).then(res => {
					if (res.code == 0) {
						this.flag = true;
						this.srcDec = require('../assets/success.png');
						this.dec = '验证成功';
						setTimeout((() => {
							this.flag = false;
						}), 1000);
						this.popVisible = false;
					} else {
						this.flag = true;
						this.srcDec = require('../assets/fail.png');
						this.dec = res.msg;
						setTimeout((() => {
							this.flag = false;
						}), 1000);
					}
				})
			},
			submit() { // 手机号类型充值提交
				if (this.accountNo === '') {
					// console.log('充值账户不能为空！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '充值账户不能为空！';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
				} else if (this.verifyCode === '') {
					// console.log('请再输一遍账户！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '请输入验证码！';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
				} else {
					if (this.chargeType == 1) { // 直充
						this.direct()
					} else if (this.chargeType == 2) { // 卡密
						this.secrit()
					}
				}

			},
			submitTX() {
				if (this.accountNo === '') {
					// console.log('充值账户不能为空！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '请输入账号';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
					return;
				}
				if (this.reAccountNo === '') {
					// console.log('请再输一遍账户！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '请再次输入账号';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
					return;
				}
				if (this.accountNo !== this.reAccountNo) {
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '请输入相同的账号';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
					return;
				} else {
					const obj = {
						// productType:this.type,
						// buyNum:1,
						accountNumber: this.accountNo,
						ticketNo: this.key,
						chargetype: this.charge
					}
					this.disabled = true;
					this.$http.POST('productTicket/rechargeProductTicket', obj).then(res => {
						// this.flag = true;
						if (res.code === 0) {
							// const customerOrderNo = res.data.customerOrderNo;
							this.minus('-1');
						} else {
							this.disabled = false;
							this.flag = true;
							this.submitTxt = '确认充值';
							this.srcDec = require('../assets/fail.png');
							this.dec = res.msg;
							setTimeout((() => {
								this.flag = false;
							}), 1000);
						}
					});
				}
			},
			direct() { // 直充提交
				const obj = {
					// productType:this.type,
					// buyNum:1,
					accountNumber: this.accountNo,
					ticketNo: this.key,
					code: this.verifyCode,
					productCategoryId: this.productCategoryId
				}
				this.disabled = true;
				this.$http.POST('productTicket/rechargeProductTicket', obj).then(res => {
					// this.flag = true;
					if (res.code === 0) {
						// const customerOrderNo = res.data.customerOrderNo;
						this.minus('-1');
					} else {
						this.disabled = false;
						this.flag = true;
						this.submitTxt = '确认充值';
						this.srcDec = require('../assets/fail.png');
						this.dec = res.msg;
						setTimeout((() => {
							this.flag = false;
						}), 1000);
					}
				});
			},
			secrit() { // 卡密提交
				const obj = {
					accountNumber: this.accountNo,
					ticketNo: this.key,
					code: this.verifyCode,
					productCategoryId: this.productCategoryId
				}
				this.disabled = true;
				this.$http.POST('productTicket/rechargeProductTicket', obj).then(res => {
					// this.flag = true;
					if (res.code === 0) {
						// const customerOrderNo = res.data.customerOrderNo;
						this.minus('-1');
					} else {
						this.disabled = false;
						this.flag = true;
						this.submitTxt = '确认';
						this.srcDec = require('../assets/fail.png');
						this.dec = res.msg;
						setTimeout((() => {
							this.flag = false;
						}), 1000);
					}
				});
			},
			getsecritOrderInfo(isVerify) {
				const obj = {
					ticketNo: this.key,
					isVerify: isVerify,
					mobile: this.accountNo
				};
				this.$http.POST('productTicket/selectProductTicket', obj).then(res => {
					this.flag = true;
					this.submitTxt = '确认充值';
					if (res.code === 0) {
						this.dec = '充值成功';
						this.srcDec = require('../assets/success.png');
						this.status = 1;
						this.$router.push({
							path: '/kamiCode',
							query: {
								key: this.key,
								mobile: this.accountNo
							}
						})
					} else {
						this.disabled = false;
						this.srcDec = require('../assets/fail.png');
						this.dec = res.msg;
					}
					setTimeout((() => {
						this.flag = false;
					}), 2000);
				});
			},
			getOrderInfo(isVerify) {
				const obj = {
					ticketNo: this.key,
					isVerify: isVerify,
					mobile: this.accountNo
				};
				this.$http.POST('productTicket/selectProductTicket', obj).then(res => {
					this.flag = true;
					this.disabled = false;
					this.submitTxt = '确认充值';
					if (res.code == 0) {
						this.dec = '充值成功';
						this.status = 1;
						this.srcDec = require('../assets/success.png');
					} else {
						if (res.code === 3001) {
							this.dec = '充值成功';
							this.status = 1;
							this.srcDec = require('../assets/success.png');
						} else {
							this.srcDec = require('../assets/fail.png');
							this.dec = res.msg;
						}
					}
					setTimeout((() => {
						this.flag = false;
					}), 2000);
				});
			}
		}
	}
</script>
<style lang="scss" scoped>
	.qqInfo {
		img {
			max-width: 100%;
			padding: 5px 0;
		}
	}

	.wrapper {
		font-size: 16px;
		height: 100%;
		position: relative;

		.use {
			height: 100%;
			position: relative;

			.head_tip {
				background: #FEFCEC;
				padding: 10px;
				// line-height: 36px;
				font-size: 14px;
				color: #F76A24;
			}

			.head {
				height: 110px;
				background: #fff;
				padding: 10px 15px 15px 15px;
				box-sizing: border-box;

				header {
					height: 85px;
					background: url('../assets/recharge_bg.png') no-repeat;
					background-size: 345px 85px;
					position: relative;
					display: flex;

					// align-items: center;
					// flex-direction: column;
					span.ico {
						position: absolute;
						bottom: 0;
						left: 0;
						border-bottom-left-radius: 4px;
						border-top-right-radius: 7px;
						font-size: 15px;
						color: #fff;
						padding: 0 4px;
						background: linear-gradient(to right, #FF8E00, #FF5500);
					}

					span.tip {
						position: absolute;
						bottom: 0;
						left: 60px;
						font-size: 14px;
					}

					.lt {
						padding: 10px 0 0 15px;
						// float: left;
						flex: 1;

						p {
							font-size: 17px;
							color: #333333;
							font-weight: bold;
						}

						span {
							font-size: 14px;
							color: #333333;
							padding-top: 2px;
						}
					}

					.logo {
						padding: 35px 8.5px 0 0;
					}

					img {
						float: right;
						width: 60px;
						height: 60px;
						padding: 12.5px;
					}
				}

				header.used {
					background: url('../assets/used_bg.png') no-repeat;
					background-size: 345px 85px;
				}
			}

			.body {
				header {
					// height: 36px;
					background: #FEFCEC;
					padding: 10px;
					// line-height: 36px;
					font-size: 14px;
					color: #F76A24;
				}

				.bd {
					padding: 16px;

					h1 {
						font-size: 18px;
						font-weight: bold;
						color: #333333;
					}

					.txt {
						margin-top: 16px;
						background: #fff;
						height: 50px;
						line-height: 50px;
						padding: 0 10px;
						display: flex;
						align-items: center;

						input {
							flex: 1;
							border: none;
							background: none;
							text-align: right;
							padding: 10px 0;
							font-size: 16px;
						}
					}
					
					.radio {
						margin-top: 16px;
						height: 50px;
						line-height: 50px;
						background: #505050;
						color: #FFFFFF;
						padding: 0 10px;
						display: flex;
						align-items: center;
						
						input {
							-webkit-appearance: none; /* remove default */
							display: block;
							margin: 10px;
							width: 24px;
							height: 24px;
							border-radius: 12px;
							cursor: pointer;
							vertical-align: middle;
							box-shadow: hsla(0,0%,100%,.15) 0 1px 1px, inset hsla(0,0%,0%,.5) 0 0 0 1px;
							background-color: hsla(0,0%,0%,.2);
							background-image: -webkit-radial-gradient( hsla(200,100%,90%,1) 0%, hsla(200,100%,70%,1) 15%, hsla(200,100%,60%,.3) 28%, hsla(200,100%,30%,0) 70% );
							background-repeat: no-repeat;
							-webkit-transition: background-position .15s cubic-bezier(.8, 0, 1, 1),
							-webkit-transform .25s cubic-bezier(.8, 0, 1, 1);
						}
						input:checked {
							-webkit-transition: background-position .2s .15s cubic-bezier(0, 0, .2, 1),
							-webkit-transform .25s cubic-bezier(0, 0, .2, 1);
						}
						input:active {
						  -webkit-transform: scale(1.5);
						  -webkit-transition: -webkit-transform .1s cubic-bezier(0, 0, .2, 1);
						}
						
						/* The up/down direction logic */
						
						input,
						input:active {
						  background-position: 0 24px;
						}
						input:checked {
						  background-position: 0 0;
						}
						input:checked ~ input,
						input:checked ~ input:active {
						  background-position: 0 -24px;
						}
					}

					.form {
						margin-top: 16px;
						display: flex;
						align-items: center;

						.code {
							display: flex;
							background: #fff;
							margin-right: 10px;
							height: 50px;
							align-items: center;
							padding: 0 10px;
							width: 200px;

							span {
								flex: 1;
							}

							input {
								width: 108px;
								border: none;
								background: none;
								text-align: right;
								padding: 10px 0;
								font-size: 16px;
							}
						}

						button,
						em {
							color: #fff;
							width: 120px;
							height: 30px;
							line-height: 30px;
							background: linear-gradient(to right, #FF8C37, #FF7201);
							font-size: 15px;
							border-radius: 15px;
							text-align: center;
							font-style: normal;
						}

						em {
							background: #555555;
						}
					}
				}

				.ft {
					padding: 4px 16px 0 16px;
					font-size: 16px;
					color: #F76A24;
				}
			}

			.bd1 {
				display: flex;
				justify-content: center;
				align-items: center;

				.nodata {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					padding-top: 50px;

					img {
						width: 100px;
						height: 100px;
					}

					p {
						font-size: 17px;
						color: #555555;
						padding-top: 10px;
					}
				}

				.ft {
					padding: 4px 16px 0 16px;
					font-size: 16px;
					color: #888888;
				}
			}

			.foot {
				// position: absolute;
				// bottom: 0;
				padding: 70px 16px 16px 16px;
				display: flex;
				width: 100%;
				box-sizing: border-box;

				button {
					flex: 1;
					height: 60px;
					line-height: 60px;
					color: #fff;
					background: linear-gradient(to right, #F9AF2F, #F5881A);
					font-size: 17px;
					border-radius: 8px;
				}
			}

			.gz {
				padding: 24px 17px;
				background: #F3F3F3;

				h1 {
					font-size: 20px;
					color: #333333;
					font-weight: bold;
				}

				.tip {
					color: #666666;
					font-size: 15px;
					line-height: 28px;
				}

				.caption {
					img {
						max-width: 100%;
						padding: 5px 0;
					}

					p {
						color: #666666;
						font-size: 15px;
						line-height: 28px;
					}
				}
			}
		}

		.result {
			position: fixed;
			width: 100%;
			height: 100%;
			left: 0;
			top: 0px;
			display: flex;
			justify-content: center;
			align-items: center;
			z-index: 999;

			.dec {
				min-width: 120px;
				height: 120px;
				background: rgba(58, 58, 58, 0.9);
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				border-radius: 2px;
				padding: 0 10px;

				img {
					width: 36px;
					height: 36px;
					font-size: 14px;
				}

				p {
					font-size: 14px;
					color: #fff;
					padding-top: 8px;
				}
			}
		}

		.use_loading {
			position: absolute;
			height: 100%;
			width: 100%;
			z-index: 11;
			left: 0;
			top: 0;

			.loading {
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.5);
				display: flex;
				justify-content: center;
				align-items: center;

				img {
					width: 50px;
					height: 50px;
					animation: turn 1s linear infinite;
					margin: 100px auto;
				}

				@keyframes turn {
					0% {
						-webkit-transform: rotate(0deg);
					}

					25% {
						-webkit-transform: rotate(90deg);
					}

					50% {
						-webkit-transform: rotate(180deg);
					}

					75% {
						-webkit-transform: rotate(270deg);
					}

					100% {
						-webkit-transform: rotate(360deg);
					}
				}
			}
		}

		.pop {
			position: fixed;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			background: rgba(0, 0, 0, 0.5);
			display: flex;
			justify-content: center;
			align-items: center;

			.win {
				width: 325px;
				height: 350px;

				p {
					text-align: right;
					padding-bottom: 10px;

					i {
						display: inline-block;
						width: 31px;
						height: 31px;
						background: url('../assets/close.png') no-repeat;
						background-size: 31px 31px;
					}
				}

				.box {
					width: 100%;
					height: 310px;
					background: #F3F3F3;
					border-radius: 7px;
					padding: 30px 15px;
					box-sizing: border-box;

					.submit {
						margin: 30px 25px 0 25px;
						width: 245px;
						height: 44px;
						border-radius: 22px;
						color: #fff;
						font-size: 18px;
						font-weight: bolder;
						background: linear-gradient(to right, #FF9A4F, #FF7509);
					}

					.qqMusic {
						color: #F76A24;

						p {
							text-align: left;
						}
					}

					h1 {
						font-size: 18px;
						color: #333333;
						font-weight: bolder;
						padding-bottom: 16px;
					}

					.txt {
						margin-top: 16px;
						background: #fff;
						height: 50px;
						line-height: 50px;
						padding: 0 10px;
						display: flex;
						align-items: center;

						input {
							flex: 1;
							border: none;
							background: none;
							text-align: right;
							padding: 10px 0;
							font-size: 16px;
						}
					}

					.form {
						margin-top: 16px;
						display: flex;
						align-items: center;

						.code {
							display: flex;
							background: #fff;
							margin-right: 10px;
							height: 50px;
							align-items: center;
							padding: 0 10px;
							width: 200px;

							span {
								flex: 1;
							}

							input {
								width: 108px;
								border: none;
								background: none;
								text-align: right;
								padding: 10px 0;
								font-size: 16px;
							}
						}

						button,
						em {
							color: #fff;
							width: 120px;
							height: 30px;
							line-height: 30px;
							background: linear-gradient(to right, #FF8C37, #FF7201);
							font-size: 15px;
							border-radius: 15px;
							text-align: center;
							font-style: normal;
						}

						em {
							background: #555555;
						}
					}

					h4 {
						font-size: 18px;
						color: #FBB50B;
						font-weight: bolder;
						padding-bottom: 16px;
					}

					label {
						font-size: 16px;
						color: #FBB50B;
						font-weight: bolder;
						padding-bottom: 16px;
					}
				}
			}
		}
	}
</style>
